/**
 * ALS-366: how a row came to point at a product the catalogue already has: its link matched one,
 * a person accepted the suggestion, or picked one by hand. Its tooltip says which. On its own so
 * the copy can key its words by it without importing the draft's rules.
 */
export const LinkedBy = {
    Link: 'link',
    Suggestion: 'suggestion',
    Hand: 'hand',
} as const;

export type LinkedBy = (typeof LinkedBy)[keyof typeof LinkedBy];
